module.exports = __webpack_public_path__ + "static/media/Img-02.7c6eab4e.png";